import React from 'react';
import { LEGAL_DOCUMENTS, LegalDocKind, PRIVACY_POLICY_URL } from './legalDocuments';

/** Ссылки в тексте документа делаем кликабельными (политика — PDF на fmeter.ru). */
const withLinks = (text: string) => {
  const parts = text.split(/(https?:\/\/\S+?)(?=[.,;]?(?:\s|$))/g);
  return parts.map((part, i) =>
    /^https?:\/\//.test(part) ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#e3282a] underline break-all"
      >
        {part === PRIVACY_POLICY_URL ? 'Политика обработки персональных данных' : part}
      </a>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
};

/** Текст юридического документа: одинаково в модалке и на отдельной странице. */
export const LegalDocumentContent: React.FC<{ kind: LegalDocKind }> = ({ kind }) => {
  const doc = LEGAL_DOCUMENTS[kind];
  return (
    <div className="text-sm leading-[160%] text-[#343434] space-y-4">
      <p>{withLinks(doc.intro)}</p>
      {doc.sections.map((section) => (
        <section key={section.heading} className="space-y-2">
          <h3 className="font-semibold text-[#2d2c2c]">{section.heading}</h3>
          {section.blocks.map((block, i) =>
            'p' in block ? (
              <p key={i}>{withLinks(block.p)}</p>
            ) : (
              <ul key={i} className="list-disc pl-5 space-y-1">
                {block.list.map((item) => (
                  <li key={item}>{withLinks(item)}</li>
                ))}
              </ul>
            )
          )}
        </section>
      ))}
    </div>
  );
};
